import {
  Card,
  CardContent,
  Grid,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import React from "react";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { convertDateToCustomFormat } from "../../../utils/commonUtils";
export default function CounterSalesItemCard({ item }) {
  return (
    <Card
      sx={{
        width: "96%",
        mt: "12px",
        cursor: "pointer",
        backgroundColor: "#E8E8FF",
        "& .MuiCardContent-root": { p: "0rem" },
        borderRadius: "14px",
        padding: "10px ",
        paddingLeft: "30px",
        boxShadow: "none",
      }}
    >
      <CardContent sx={{ padding: "0rem 0.7rem !important" }}>
        <Grid container>
          <Grid item xs={6}>
            <Typography
              color="primary"
              sx={{
                fontSize: "14px",
                fontWeight:"500",
                overflow: "Hidden",
                display: "-webkit-box",
                "-webkit-line-clamp": "1",
                "-webkit-box-orient": "vertical",
                // fontWeight: 600,
                color: "#000000",
                padding: "0px 10px",
                borderRadius: "10px",
              }}
            >
              {item?.billDate
                ? convertDateToCustomFormat(item?.billDate?.split("T")[0])
                : convertDateToCustomFormat(item?.createdDate?.split("T")[0])}
            </Typography>
          </Grid>

          <Grid
            item
            xs={6}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CurrencyRupeeIcon color="#000000" fontSize="10px" />
            <Typography
              color="#000000"
              sx={{
                textOverflow: "ellipsis",
                fontWeight: 500,
              }}
            >
              {item?.amount?.toFixed(2)}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
